export default "__VITE_ASSET__DciSYuWa__"